"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const canonical_1 = __importDefault(require("./canonical"));
const modes_1 = require("./modes");
const uppercase_1 = __importDefault(require("./uppercase"));
exports.default = { uppercase: uppercase_1.default, canonical: canonical_1.default, modes: modes_1.modes, getMode: modes_1.getMode };
